enum ButtonColors {
    Primary = 'btn-primary',
    Secondary = 'btn-secondary',
    Danger = 'btn-danger',
    White = 'btn-white'
}

export default ButtonColors;